import { useCallback, useEffect, useMemo, useState } from 'react'
import Project from 'common/project'
import _data from 'common/utils/_data'

export function useLanguages() {
  const [languages, setLanguages] = useState([])

  const fetchLanguages = useCallback(() => {
    _data
      .get(`${Project.liveApi}legal-services/languages`)
      .then(setLanguages)
      .catch((error) => console.error(error))
  }, [])

  useEffect(fetchLanguages, [fetchLanguages])

  const dropdownLanguages = useMemo(
    () =>
      languages.map((item: { id: string; name: string }) => ({
        value: item.id,
        label: item.name,
      })),
    [languages],
  )

  return { languages, dropdownLanguages }
}
